export default __webpack_public_path__ + "static/icon-14-1-cbe551700dd6c14ea9e0948c3ef882e9.png";